<template>
  <div>
    <DashboardTemplate>
      <!-- <DepartmentNav
        v-bind:nav="{
          dashboard:false,
          smartReport:true,
        }" v-if="getRule == 'board'"
       /> -->
      <p class="title is-size-4-tablet is-size-5-mobile has-text-weight-bold">
        {{ $t("smartReport.smartReportHeader") }}
      </p>
      <ReportCompanyList />
    </DashboardTemplate>
  </div>
</template>
/* eslint-disable */
<script>
// @ is an alias to /src
import DashboardTemplate from "@/template/DashboardTemplate.vue";
import DepartmentNav from "@/components/DepartmentNav.vue";
import ReportCompanyList from "@/components/ReportCompanyList.vue";
import { mapGetters } from "vuex";

export default {
  name: "dashboard",
  components: {
    ReportCompanyList,
    DepartmentNav,
    DashboardTemplate,
  },
  computed: {
    getRule() {
      return this.$store.getters.getRule;
    },
  },
};
</script>
